export const CURRENT_USER = '**CURRENT_USER**';
export const CURRENT_USER_DEFAULT_NAME = 'Current User';
export const CURRENT_USER_DEFAULT_EMAIL = `Current user's email`;
